import { Button } from "@/components/ui/button";
import { PartyPopper, FileText } from "lucide-react";

const ParabensHero = () => {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-background to-background" />
      
      <div className="container relative">
        <div className="max-w-3xl mx-auto text-center animate-fade-in">
          {/* Celebration icon */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <PartyPopper className="h-20 w-20 text-primary animate-bounce" />
              <div className="absolute inset-0 bg-primary/20 blur-2xl rounded-full" />
            </div>
          </div>

          {/* Main heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 bg-gradient-warm bg-clip-text text-transparent">
            Parabéns! 🎉
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-muted-foreground mb-4">
            Sua compra do <strong className="text-foreground">E-book 30 Receitas Express (30 min)</strong> foi confirmada.
          </p>

          <p className="text-base md:text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Você acaba de destravar 30 almoços diferentes, rápidos e saborosos — usando ingredientes simples que você já tem em casa.
          </p>

          {/* Primary CTA */}
          <div className="flex flex-col items-center gap-4 mb-6">
            <Button
              asChild
              size="lg"
              className="bg-gradient-warm hover:shadow-hover transition-all duration-300 text-lg h-14 px-8 w-full md:w-auto"
            >
              <a 
                href="https://pxa.receitasem30minutos.com.br/lt/ebook-acesso"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FileText className="mr-2 h-5 w-5" />
                Baixar meu e-book agora
              </a>
            </Button>

            {/* Badge */}
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary/10 text-primary font-medium">
                Acesso imediato • PDF
              </span>
            </div>
          </div>

          {/* Microcopy */}
          <p className="text-sm text-muted-foreground">
            Também enviamos o e-book por <strong>e-mail</strong> e <strong>WhatsApp</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ParabensHero;
